import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import { updateUserConfigurationAndService } from "owa-userconfiguration/lib/utils/updateUserConfigurationAndService";
import { logUsage } from "owa-analytics";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

/**
 * Sets the folder pane width in the local user config and makes a call to update it in server userConfig
 * @param newFolderPaneWidth the width of navigation pane
 */
export default function setFolderPaneWidth(newFolderPaneWidth: number): void {
    const storedFolderPaneWidth = getUserConfiguration().UserOptions?.NavigationBarWidth;
    
    // Width did not change
    if (storedFolderPaneWidth == newFolderPaneWidth) {
        logUsage("FP_SetFolderPaneWidth_SameValue", getGlobalSettingsAccountMailboxInfo(), {
            newFolderPaneWidth,
        });
        return;
    }
    
    logUsage("FP_SetFolderPaneWidth_NewValue", getGlobalSettingsAccountMailboxInfo(), {
        storedFolderPaneWidth,
        newFolderPaneWidth,
    });
    
    updateUserConfigurationAndService({
        UserOptions: {
            NavigationBarWidth: newFolderPaneWidth,
        },
    });
}
